import { memo } from "react";
import { List, ListItemButton, ListItemText, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { RouteTo } from "@routing/RouteMap";

const AIServicesNavbar = memo(() => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const navItems: { label: string; path: string }[] = [
        { label: "Übersicht", path: RouteTo.AI_SERVICES },
        { label: "Quick-Wesentlichkeit", path: `${RouteTo.AI_SERVICES}/wesentlichkeit` },
        { label: "VSME Report", path: `${RouteTo.AI_SERVICES}/vsme` },
    ];

    return (
        <Paper sx={{ width: "100%", py: 1 }} elevation={2}>
            <List dense>
                {navItems.map((item) => (
                    <ListItemButton
                        key={item.path}
                        selected={
                            // Highlight if exact match, or for non-root items also when the current path is a sub-route
                            pathname === item.path ||
                            (item.path !== RouteTo.AI_SERVICES && pathname.startsWith(item.path + "/"))
                        }
                        onClick={() => navigate(item.path)}
                    >
                        <ListItemText primary={item.label} />
                    </ListItemButton>
                ))}
            </List>
        </Paper>
    );
});

export default AIServicesNavbar; 